var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.387,
    height: 48.12,
    viewBox: "0 0 33.387 48.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(-22.4 -4.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7297",
    "data-name": "Path 7297",
    d: "M95,83.5H93.7v2.1a11.479,11.479,0,0,1,1.013,4.725V92.3h.55v2.266h-.55v1.661a2.263,2.263,0,0,0,1.71-2.193V84.927A1.422,1.422,0,0,0,95,83.5Z",
    transform: "translate(-41.665 -46.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7298",
    "data-name": "Path 7298",
    d: "M95,83.5H93.7v2.1a11.48,11.48,0,0,1,1.008,4.531,1.823,1.823,0,0,0,.833.208h.882V84.927A1.422,1.422,0,0,0,95,83.5Z",
    transform: "translate(-41.665 -46.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7299",
    "data-name": "Path 7299",
    d: "M25.892,94.566V92.3h.55V90.335a11.486,11.486,0,0,1,1.013-4.725v-2.1h-1.3a1.421,1.421,0,0,0-1.421,1.421v9.107a2.263,2.263,0,0,0,1.71,2.193V94.566h-.55Z",
    transform: "translate(-1.306 -46.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7300",
    "data-name": "Path 7300",
    d: "M27.456,85.611v-2.1h-1.3a1.421,1.421,0,0,0-1.421,1.421v5.421h.882a1.818,1.818,0,0,0,.833-.208,11.472,11.472,0,0,1,1.008-4.53Z",
    transform: "translate(-1.307 -46.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7301",
    "data-name": "Path 7301",
    d: "M36.553,75.241H31.3v5.533A11.57,11.57,0,0,1,36.553,75.241Z",
    transform: "translate(-5.148 -41.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7302",
    "data-name": "Path 7302",
    d: "M86.289,80.774V75.241H81.033A11.57,11.57,0,0,1,86.289,80.774Z",
    transform: "translate(-34.251 -41.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7303",
    "data-name": "Path 7303",
    d: "M78.7,52.254H75.75a2.1,2.1,0,0,1-.362.792l-.251.672-1.982,2.694h-.473c.032-.054.058-.111.089-.166a8.982,8.982,0,0,1-5.736,4.274h.548a11.471,11.471,0,0,1,5.259,1.271H78.7a2.629,2.629,0,0,0,2.629-2.629V54.883A2.629,2.629,0,0,0,78.7,52.254Z",
    transform: "translate(-26.06 -27.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7304",
    "data-name": "Path 7304",
    d: "M31.991,61.791A11.476,11.476,0,0,1,37.25,60.52h.231a8.982,8.982,0,0,1-5.736-4.273c.031.054.057.112.089.165h-.473L29.415,53.79l-.278-.734h0a2.091,2.091,0,0,1-.37-.8H26.129A2.629,2.629,0,0,0,23.5,54.884v4.279a2.629,2.629,0,0,0,2.629,2.629h5.862Z",
    transform: "translate(-0.585 -27.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7305",
    "data-name": "Path 7305",
    d: "M85.914,52.254a2.1,2.1,0,0,1-.362.792l-.251.672-.9,1.218V61.79h2.631V52.254Z",
    transform: "translate(-36.225 -27.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7306",
    "data-name": "Path 7306",
    d: "M36.01,53.79l-.278-.734h0a2.091,2.091,0,0,1-.37-.8H34.77v9.536H37.4V55.664Z",
    transform: "translate(-7.18 -27.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7307",
    "data-name": "Path 7307",
    d: "M45.241,72.178h-.562a8.724,8.724,0,0,1-4.052,0h-.245A11.528,11.528,0,0,0,28.854,83.706v8H56.769v-8A11.528,11.528,0,0,0,45.241,72.178Z",
    transform: "translate(-3.718 -39.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7308",
    "data-name": "Path 7308",
    d: "M32.173,82.888a11.476,11.476,0,0,0-3.318,8.079v.971H34.4V87.5a5.9,5.9,0,0,0-2.226-4.615Z",
    transform: "translate(-3.719 -45.727)",
    fill: "#f9a720"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7309",
    "data-name": "Path 7309",
    d: "M88.326,90.966a11.477,11.477,0,0,0-3.318-8.079A5.9,5.9,0,0,0,82.782,87.5v4.435h5.544v-.971Z",
    transform: "translate(-35.274 -45.726)",
    fill: "#f9a720"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7310",
    "data-name": "Path 7310",
    d: "M52.61,75.343l-1.074,5.591-2.729-2.67c-.711,1.059-1.316,1.841-1.316,1.841s-.6-.783-1.316-1.841l-2.729,2.67L42.37,75.339a11.513,11.513,0,0,0-5.533,3.126,5.9,5.9,0,0,1,2.232,4.62V93.558H55.9V83.085a5.9,5.9,0,0,1,2.232-4.62,11.511,11.511,0,0,0-5.518-3.123Z",
    transform: "translate(-8.389 -41.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7311",
    "data-name": "Path 7311",
    d: "M60.569,72.178h-.562a8.724,8.724,0,0,1-4.052,0H55.71c-.222,0-.443.008-.662.02l2.146,3.861-.363.356c.711,1.059,1.316,1.841,1.316,1.841s.6-.783,1.316-1.841l-.363-.356L61.245,72.2c-.224-.013-.449-.022-.677-.022Z",
    transform: "translate(-19.046 -39.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7312",
    "data-name": "Path 7312",
    d: "M49.735,72.566l1.258,6.547,3.093-3.025-2.148-3.861A11.53,11.53,0,0,0,49.735,72.566Z",
    transform: "translate(-15.937 -39.489)",
    fill: "#f9a720"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7313",
    "data-name": "Path 7313",
    d: "M66.96,72.23l-2.145,3.86,3.093,3.025,1.257-6.543A11.455,11.455,0,0,0,66.96,72.23Z",
    transform: "translate(-24.761 -39.49)",
    fill: "#f9a720"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7314",
    "data-name": "Path 7314",
    d: "M82.782,104.7h6.094v2.266H82.782Z",
    transform: "translate(-35.274 -58.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7315",
    "data-name": "Path 7315",
    d: "M27.529,104.7h6.094v2.266H27.529Z",
    transform: "translate(-2.943 -58.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7316",
    "data-name": "Path 7316",
    d: "M50.2,9.5a18.908,18.908,0,0,1,8.72,1.977,9.5,9.5,0,0,0-17.439,0A18.908,18.908,0,0,1,50.2,9.5Z",
    transform: "translate(-11.107 -0.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7317",
    "data-name": "Path 7317",
    d: "M50.212,13.12a18.914,18.914,0,0,1,8.711,1.973,9.467,9.467,0,0,0-.9-1.624,20.616,20.616,0,0,0-15.632,0,9.523,9.523,0,0,0-.9,1.624A18.914,18.914,0,0,1,50.212,13.12Z",
    transform: "translate(-11.119 -4.206)",
    fill: "#842014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7318",
    "data-name": "Path 7318",
    d: "M43.888,14.8c-7.288,0-13.195,3.544-13.195,7.916a6.016,6.016,0,0,0,2.333,4.492v-.7a10.7,10.7,0,1,1,21.408,0v.965a6.191,6.191,0,0,0,2.649-4.757c0-4.372-5.908-7.916-13.2-7.916Z",
    transform: "translate(-4.794 -5.884)",
    fill: "#f9a720"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7319",
    "data-name": "Path 7319",
    d: "M84.084,46.261a1.012,1.012,0,0,0-.528.154v1.868a9.026,9.026,0,0,1-.127,1.5,1.047,1.047,0,0,0,.655.251c.738,0,1.337-.845,1.337-1.887s-.6-1.887-1.337-1.887Z",
    transform: "translate(-35.653 -24.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7320",
    "data-name": "Path 7320",
    d: "M37.87,48.283V46.415a1.01,1.01,0,0,0-.528-.154c-.738,0-1.337.845-1.337,1.887s.6,1.887,1.337,1.887A1.047,1.047,0,0,0,38,49.783,9.026,9.026,0,0,1,37.87,48.283Z",
    transform: "translate(-7.903 -24.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7321",
    "data-name": "Path 7321",
    d: "M56.83,35.5a6.115,6.115,0,0,1-.666-1.772s-8.575,4.5-15.65,2.528c0,.087-.013.171-.013.258v4.436a8.968,8.968,0,1,0,17.936,0V39.079l-.019-1.837A8.408,8.408,0,0,1,56.83,35.5Z",
    transform: "translate(-10.533 -16.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7322",
    "data-name": "Path 7322",
    d: "M79.237,74.6a11.48,11.48,0,0,0-2.513-1.14V83.909a2.513,2.513,0,0,0,2.513,2.513Z",
    transform: "translate(-31.73 -40.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7323",
    "data-name": "Path 7323",
    d: "M44.731,73.463a11.461,11.461,0,0,0-2.513,1.14V86.423a2.513,2.513,0,0,0,2.513-2.513Z",
    transform: "translate(-11.538 -40.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4882",
    "data-name": "Group 4882",
    transform: "translate(22.5 4.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7324",
    "data-name": "Path 7324",
    d: "M52.644,34.4a3.047,3.047,0,0,0,3.043-3.043V27.082a3.047,3.047,0,0,0-3.043-3.044H50.176c0-.061.007-.122.007-.185a2.68,2.68,0,0,0-.543-1.677v-.088A6.727,6.727,0,0,0,52.7,16.829c0-2.469-1.766-4.69-4.564-6.217a9.906,9.906,0,0,0-18.093,0c-2.8,1.527-4.564,3.748-4.564,6.217a6.556,6.556,0,0,0,2.748,5.013v.334a2.679,2.679,0,0,0-.543,1.677c0,.062,0,.124.007.185H25.543A3.047,3.047,0,0,0,22.5,27.082V31.36A3.047,3.047,0,0,0,25.543,34.4h.191V37h-.887a1.839,1.839,0,0,0-1.836,1.837v9.107a2.668,2.668,0,0,0,1.71,2.488v1.815a.415.415,0,0,0,.415.415H39.094a.415.415,0,0,0,.415-.415v-13.3c.152-.2.52-.693.973-1.349l2.375,2.324a.414.414,0,0,0,.29.118.424.424,0,0,0,.124-.019.415.415,0,0,0,.283-.318l1.025-5.338V43.7a2.93,2.93,0,0,0,2.513,2.9v5.241H44.5a.415.415,0,0,0,0,.83h8.553a.415.415,0,0,0,.415-.415V50.433a2.668,2.668,0,0,0,1.71-2.488V38.839A1.839,1.839,0,0,0,53.34,37h-.887V34.4h.191Zm2.214-7.322V31.36a2.216,2.216,0,0,1-2.214,2.214H51.227V24.867h1.418a2.216,2.216,0,0,1,2.214,2.214Zm-9.17,5.972c-.118-.044-.239-.085-.359-.125-.07-.024-.139-.051-.21-.073h-.007q-.3-.093-.6-.172l-.007,0q-.287-.074-.58-.133l-.017,0c-.179-.036-.359-.069-.541-.1-.1-.015-.2-.027-.3-.039A9.447,9.447,0,0,0,47.1,28.6l.663-.9v5.877h-.889l-.073-.036-.172-.084q-.18-.086-.364-.165c-.084-.037-.169-.071-.254-.106-.108-.044-.217-.088-.326-.129Zm-7.009,18.78H31.095V46.593a2.93,2.93,0,0,0,2.513-2.9V34.285l1.04,5.417a.415.415,0,0,0,.7.219L37.721,37.6c.438.633.8,1.115.957,1.329V51.834ZM28,25.186a1.852,1.852,0,0,0,.854.841l1.91,2.572a9.448,9.448,0,0,0,4.092,3.84c-.084.013-.166.029-.25.044-.309.053-.615.115-.916.192l-.005,0c-.207.053-.412.113-.614.177h-.007c-.071.022-.139.049-.209.073-.12.041-.241.081-.359.125s-.218.085-.326.129c-.085.035-.17.07-.254.106q-.184.08-.364.165c-.058.027-.115.056-.173.085l-.072.035h-.675V28.421l-.83-1.118v6.271H28Zm20.223.1c0-.009,0-.017,0-.026.025-.185.044-.372.058-.561,0-.036.006-.071.008-.107.012-.2.021-.4.021-.6V22.393c.535-.114,1.034.6,1.034,1.46C49.353,24.758,48.806,25.525,48.228,25.282Zm-.373-5.024,0,0Zm-.366-.327v4.058c0,.265-.016.526-.04.785-.011.114-.028.229-.044.344a8.565,8.565,0,0,1-6.551,7.2c-.137.032-.273.058-.409.083-.182.032-.364.063-.549.084-.079.009-.158.014-.237.021-.223.019-.448.033-.675.034h-.1c-.227,0-.452-.015-.675-.034-.08-.007-.159-.012-.239-.021-.185-.021-.367-.051-.548-.084-.136-.025-.272-.052-.409-.083a8.565,8.565,0,0,1-6.553-7.207c-.015-.111-.032-.222-.042-.334-.024-.26-.04-.522-.04-.788V19.552c0-.053.007-.1.008-.156,6.993,1.691,15.241-2.63,15.241-2.63a6.129,6.129,0,0,0,.666,1.772,7.035,7.035,0,0,0,1.192,1.393ZM25.551,44.246a11.056,11.056,0,0,1,2.426-6.918,5.447,5.447,0,0,1,2.289,4.448V45.8H25.551Zm2.974-7.556a11.212,11.212,0,0,1,1.74-1.521v3.469A6.279,6.279,0,0,0,28.525,36.69Zm2.57,5.086V34.635l.161-.093c.2-.11.394-.216.6-.313.073-.035.148-.067.222-.1.19-.086.382-.168.577-.244l.126-.05V43.7a2.1,2.1,0,0,1-1.683,2.057Zm3.253-8.4c.219-.046.44-.088.663-.121l.034,0c.222-.032.445-.057.669-.076l.054,0,1.865,3.352-2.315,2.264-1.036-5.4Zm-4.908-11a.542.542,0,0,1,.112.012v1.6c0,.007,0,.013,0,.02,0,.193.008.385.02.575,0,.039.006.079.009.119q.021.274.057.545c0,.012,0,.023,0,.034-.577.243-1.125-.524-1.125-1.429C28.518,23.055,28.94,22.381,29.44,22.381Zm-4.3,25.681H25V46.626h5.264v1.437Zm27.5-3.816V45.8H47.922v-4.02a5.447,5.447,0,0,1,2.289-4.448A11.058,11.058,0,0,1,52.637,44.246Zm-4.714-5.609V35.169a11.193,11.193,0,0,1,1.74,1.521A6.284,6.284,0,0,0,47.922,38.638Zm0,7.988h5.264v1.437H47.922ZM50.4,24.867v8.706H48.6v-7l-.653.887,1.043-1.417a1.965,1.965,0,0,0,1.022-1.172ZM31.3,9.993a9.082,9.082,0,0,1,15.589,0,17.507,17.507,0,0,0-2.36-.8l-.169-.046q-.22-.056-.443-.107c-.163-.038-.329-.073-.5-.108-.1-.022-.208-.044-.314-.064-.261-.049-.527-.093-.794-.133L42.063,8.7c-.291-.04-.584-.076-.881-.1h-.01c-.3-.029-.612-.049-.923-.065l-.221-.01c-.309-.013-.62-.022-.935-.022s-.626.009-.935.022l-.221.01c-.31.016-.619.036-.923.065h-.01c-.3.028-.59.064-.881.1l-.249.035c-.268.04-.533.083-.794.133-.106.02-.209.043-.314.064-.166.034-.332.07-.5.108-.149.034-.3.07-.443.107l-.169.046A17.507,17.507,0,0,0,31.3,9.993Zm-4.986,6.837c0-2.2,1.618-4.177,4.192-5.55a.381.381,0,0,0,.062-.022,17.448,17.448,0,0,1,6.181-1.8l.039,0q.548-.06,1.106-.09l.085,0c.37-.019.742-.03,1.116-.03s.746.011,1.116.03l.085,0q.558.031,1.106.09l.039,0a17.445,17.445,0,0,1,6.181,1.8.394.394,0,0,0,.075.029c2.566,1.373,4.18,3.349,4.18,5.543A5.644,5.644,0,0,1,49.64,21.06v-.438a10.7,10.7,0,0,0-21.408,0v.153A5.466,5.466,0,0,1,26.313,16.829Zm-.77,16.744A2.216,2.216,0,0,1,23.33,31.36V27.082a2.216,2.216,0,0,1,2.214-2.214h1.632v8.706H25.543Zm4.362.83c-.083.057-.163.119-.245.178-.057.042-.116.083-.172.125-.1.073-.192.149-.286.225-.059.047-.118.094-.176.142-.09.075-.178.152-.265.23-.06.053-.12.106-.179.161-.083.077-.165.156-.246.234-.06.058-.12.117-.178.177-.078.079-.154.16-.229.241-.058.063-.117.126-.174.19s-.117.132-.175.2a.331.331,0,0,0-.035.037s0,.006,0,.01h0q-.085.1-.168.2-.1.126-.2.254c-.054.071-.107.142-.159.214s-.125.173-.186.262-.1.15-.151.225c-.037.056-.075.11-.111.166V34.4h3.34Zm-6.064,4.435a1.008,1.008,0,0,1,1.006-1.007h.887v1.6c-.012.027-.022.054-.033.08-.04.092-.077.185-.115.278-.025.062-.052.124-.076.187l-.033.089c-.034.089-.064.18-.1.27-.022.063-.044.125-.065.188l-.039.119c-.026.081-.049.164-.073.246-.018.061-.036.122-.053.183s-.03.1-.044.158c-.019.073-.035.148-.053.222-.013.056-.027.112-.039.168s-.032.135-.046.2-.024.136-.037.2c-.009.046-.017.093-.026.14-.015.085-.032.169-.045.254-.01.063-.016.127-.024.19,0,.033-.009.066-.013.1-.013.1-.029.208-.039.312-.006.058-.009.117-.014.176,0,.015,0,.029,0,.044h0c-.011.129-.023.257-.029.386,0,.048,0,.1,0,.145a1.379,1.379,0,0,1-.426.069h-.467Zm0,9.107V44.675h.467a2.089,2.089,0,0,0,.413-.042V45.8h-.135a.415.415,0,0,0-.415.415v2.266a.415.415,0,0,0,.415.415h.135v.627A1.845,1.845,0,0,1,23.841,47.946Zm1.711.946h4.713v2.942H25.552ZM39.1,38.1c-.2-.271-.474-.652-.778-1.1l.116-.113a.434.434,0,0,0,.073-.5l-.114-.2-1.7-3.06h.145a9.308,9.308,0,0,0,4.187,0h.476L39.692,36.4a.415.415,0,0,0-.048.261.391.391,0,0,0,.013.043.411.411,0,0,0,.107.194l.116.113C39.576,37.452,39.3,37.833,39.1,38.1Zm3.783.684-2.177-2.13-.137-.134,1.863-3.351.049,0c.231.019.461.045.689.079l.015,0c.219.033.436.074.651.119l.083.019Zm2.524,4.91V33.836l.126.05c.195.076.387.157.577.244.074.034.149.065.222.1.2.1.4.2.6.313l.161.093V45.755A2.1,2.1,0,0,1,45.409,43.7Zm2.513,8.136V48.892h4.714v2.942Zm6.424-3.888a1.844,1.844,0,0,1-.88,1.574v-.627H53.6a.415.415,0,0,0,.415-.415V46.211A.415.415,0,0,0,53.6,45.8h-.135V44.633a2.089,2.089,0,0,0,.413.042h.467v3.271ZM53.34,37.832a1.008,1.008,0,0,1,1.006,1.007v5.006h-.467a1.347,1.347,0,0,1-.425-.07c0-.048,0-.1,0-.145-.007-.129-.019-.258-.029-.386h0c0-.015,0-.029,0-.044,0-.058-.008-.117-.014-.176-.011-.1-.026-.208-.039-.312,0-.033-.008-.066-.013-.1-.009-.063-.015-.127-.024-.19-.013-.085-.03-.169-.045-.254-.008-.046-.017-.093-.026-.14-.013-.068-.024-.136-.037-.2s-.031-.135-.046-.2-.026-.112-.039-.168c-.018-.074-.034-.149-.053-.222-.014-.053-.029-.105-.044-.158s-.035-.122-.053-.183c-.024-.082-.047-.165-.073-.246-.012-.039-.026-.079-.039-.119-.021-.063-.044-.125-.065-.188-.032-.09-.062-.18-.1-.27-.011-.03-.022-.059-.033-.089-.024-.063-.051-.124-.076-.187-.037-.093-.075-.186-.115-.278-.012-.027-.022-.054-.033-.08v-1.6h.886ZM51.623,37v.875c-.036-.056-.074-.11-.111-.166-.05-.076-.1-.151-.151-.225s-.123-.175-.186-.262-.105-.144-.159-.214c-.066-.086-.132-.171-.2-.254q-.083-.1-.168-.2v0s0-.006,0-.009a.34.34,0,0,0-.032-.033c-.058-.069-.118-.136-.178-.2s-.115-.127-.174-.19c-.076-.081-.152-.162-.229-.241-.059-.06-.119-.118-.178-.177-.081-.079-.163-.158-.246-.234-.059-.054-.119-.107-.179-.161-.088-.078-.175-.155-.265-.23-.058-.048-.117-.095-.176-.142-.095-.076-.189-.152-.286-.225-.057-.043-.115-.083-.172-.125-.082-.059-.162-.121-.245-.178h3.341V37Z",
    transform: "translate(-22.5 -4.743)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7325",
    "data-name": "Path 7325",
    d: "M64.639,91.864a.517.517,0,1,0-.517-.517A.517.517,0,0,0,64.639,91.864Z",
    transform: "translate(-46.855 -55.117)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7326",
    "data-name": "Path 7326",
    d: "M64.639,99.395a.517.517,0,1,0-.517-.517A.517.517,0,0,0,64.639,99.395Z",
    transform: "translate(-46.855 -59.524)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7327",
    "data-name": "Path 7327",
    d: "M64.639,106.925a.517.517,0,1,0-.517-.517A.517.517,0,0,0,64.639,106.925Z",
    transform: "translate(-46.855 -63.93)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7328",
    "data-name": "Path 7328",
    d: "M65.156,113.937a.517.517,0,1,0-.517.517A.517.517,0,0,0,65.156,113.937Z",
    transform: "translate(-46.855 -68.336)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7329",
    "data-name": "Path 7329",
    d: "M68.158,118.257h-2.1a.415.415,0,1,0,0,.83h2.1a.415.415,0,0,0,0-.83Z",
    transform: "translate(-47.746 -71.166)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7330",
    "data-name": "Path 7330",
    d: "M51.316,45.947a.9.9,0,1,0,.9.9A.9.9,0,0,0,51.316,45.947Z",
    transform: "translate(-38.837 -28.854)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7331",
    "data-name": "Path 7331",
    d: "M70.391,45.947a.9.9,0,1,0,.9.9A.9.9,0,0,0,70.391,45.947Z",
    transform: "translate(-49.999 -28.854)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7332",
    "data-name": "Path 7332",
    d: "M60.1,55.279a1.436,1.436,0,0,0,1.435-1.435v-.6a.415.415,0,1,0-.83,0v.6a.6.6,0,1,1-1.21,0v-.6a.415.415,0,1,0-.83,0v.6A1.435,1.435,0,0,0,60.1,55.279Z",
    transform: "translate(-43.66 -32.883)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7333",
    "data-name": "Path 7333",
    d: "M71.418,42.292l-1.756-.306a.415.415,0,1,0-.143.817l1.756.306a.423.423,0,0,0,.072.006.415.415,0,0,0,.071-.823Z",
    transform: "translate(-49.813 -26.533)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7334",
    "data-name": "Path 7334",
    d: "M50.928,41.987l-1.756.306a.415.415,0,0,0,.071.823.424.424,0,0,0,.072-.006l1.756-.306a.415.415,0,0,0-.143-.817Z",
    transform: "translate(-37.907 -26.533)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7335",
    "data-name": "Path 7335",
    d: "M60.77,60.332a2.184,2.184,0,0,1-1.658.756,2.111,2.111,0,0,1-1.652-.748.415.415,0,0,0-.671.487,2.945,2.945,0,0,0,2.324,1.09,3.023,3.023,0,0,0,2.318-1.082.415.415,0,0,0-.66-.5Z",
    transform: "translate(-42.518 -37.176)",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampers);
export default __webpack_public_path__ + "static/media/campers.ed3d6979657a14cb0a69849a5692ffdd.svg";
export { ForwardRef as ReactComponent };